import { styled } from '@mui/material';

export const TextWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '4px',
});
